@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
}

.recording-icon-animating {
    animation: pulse 1.5s ease-in-out infinite;
}
